import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ForgotPasswordModal from "./ForgotPassword"; 
import { BASE_URL } from "./Config";
import ReactDOM from "react-dom";
import { FiEye, FiEyeOff } from 'react-icons/fi';

export default function LoginForm({ showToast }) {
  const [formData, setFormData] = useState({
    user_name: "",
    password: "",
  });
  const [status, setStatus] = useState("");
  const [showForgotModal, setShowForgotModal] = useState(false); // modal control
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginCard, setLoginCard] = useState({ show: false, message: "", success: false });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleForgotPassword = () => {
    setShowForgotModal(true);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/api/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      if (response.ok) {
        const token =
          data.token || data.accessToken || data.access_token || (data.data && data.data.token);
        if (token) {
          localStorage.setItem("accessToken", token);
          localStorage.setItem("token", token);
          setLoginCard({ show: true, message: "Login successful! Redirecting...", success: true });
          setTimeout(() => {
            setLoginCard({ show: false, message: "", success: false });
            navigate("/dashboard");
          }, 1500);
        } else {
          setLoginCard({ show: true, message: "Login failed: No token received.", success: false });
          setTimeout(() => setLoginCard({ show: false, message: "", success: false }), 2000);
        }
      } else {
        setLoginCard({ show: true, message: data.message || "Incorrect Password or Username", success: false });
        setTimeout(() => setLoginCard({ show: false, message: "", success: false }), 2000);
      }
    } catch (error) {
      setLoginCard({ show: true, message: "Network or server error. Please try again.", success: false });
      setTimeout(() => setLoginCard({ show: false, message: "", success: false }), 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loginCard.show && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.18)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            padding: '2.5rem 2.5rem 2rem 2.5rem',
            minWidth: 340,
            maxWidth: 400,
            textAlign: 'center',
            fontFamily: 'Poppins, Segoe UI, sans-serif',
          }}>
            <h2 style={{ color: loginCard.success ? '#11998e' : '#b91c1c', fontWeight: 700, fontSize: 24, marginBottom: 12 }}>Login</h2>
            <div style={{ color: '#444', fontSize: 18, marginBottom: 8 }}>{loginCard.message}</div>
            {loginCard.success && <div style={{ color: '#888', fontSize: 14 }}>Redirecting...</div>}
          </div>
        </div>
      )}
      <form onSubmit={handleLogin} className="login-form-responsive">
        <label style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%'}}> Username</label>
        <input
          type="text"
          name="user_name"
          placeholder="Username"
          value={formData.user_name}
          onChange={handleChange}
          required
          style={{
            width: '100%',
            height: '53px',
            opacity: 1,
            borderRadius: '8px',
            padding: '16px',
            borderWidth: '1px',
            border: '1px solid rgba(221, 221, 221, 1)',
            fontSize: '16px',
            outline: 'none',
            transition: 'border-color 0.2s',
            boxSizing: 'border-box',
            marginBottom: 12
          }}
          className="focus:border-teal-500"
        />
        <label style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%'}}> Password</label>
        <div className="relative w-full mb-4">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              height: '53px',
              opacity: 1,
              borderRadius: '8px',
              padding: '16px',
              paddingRight: '48px',
              borderWidth: '1px',
              border: '1px solid rgba(221, 221, 221, 1)',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              boxSizing: 'border-box',
              marginBottom: 12
            }}
            className="focus:border-teal-500"
          />
          <span
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-blue-500 cursor-pointer transition-colors duration-200"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            tabIndex={0}
          >
            {showPassword ? <FiEye size={20} /> : <FiEyeOff size={20} />}
          </span>
        </div>
        <div style={{width: '100%', marginBottom: 16}}>
          <button 
            type="submit" 
            disabled={loading} 
            className={`text-white font-semibold transition-all duration-300 w-full ${
              loading 
                ? 'opacity-80 cursor-not-allowed' 
                : 'hover:opacity-90'
            }`}
            style={{
              width: '100%',
              height: '40px',
              opacity: 1,
              borderRadius: '8px',
              background: 'rgba(15, 150, 144, 1)',
              border: 'none',
              outline: 'none',
              fontSize: 16,
              fontWeight: 600
            }}
          >
            {loading ? (
              <span className="inline-block w-5 h-5 border-2 border-white border-t-blue-500 rounded-full animate-spin"></span>
            ) : (
              'LOGIN'
            )}
          </button>
        </div>
      </form>
      {/* Show Forgot Password Modal using Portal */}
      {showForgotModal && ReactDOM.createPortal(
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />
        </div>,
        document.body
      )}
    </>
  );
}
